export default {
  manage: {
    label: 'جولات إرشادية',
    desc: 'إدارة الجولات الإرشادية',
    reset: 'إعادة مشاهدة الجولة الإرشادية',
    completed: 'مكتملة',
    pristine: 'لم تبدأ',
    activate: 'تفعيل الجولات الإرشادية',
    deactivateInfo: 'يمكنكم الدخول إلى ملفكم الشخصي لإعادة تفعيل جميع الزيارات الموجَّهة.'
  },
  buttons: {
    next: 'التالي',
    prev: 'السابق',
    done: 'إنهاء',
    deactivate: 'إيقاف الزيارات الموجَّهة'
  },
  tour: {
    patient: {
      header: {
        serviceTitle: 'خدمة الرعاية الخاصة بك',
        serviceDesc: 'هذه الخدمة مسؤولة عن مرافقتك الطبية. تقوم بتجميع معلوماتك وتنسيق رعايتك وإرسال المستندات أو الرسائل المفيدة لمسارك الصحي.',
        notificationsTitle: 'مركز الإشعارات',
        notificationsDesc: 'اطّلع على إشعاراتك الجديدة المتعلقة بمتابعتك.',
        profileTitle: 'الملف الشخصي والإعدادات',
        profileDesc: 'ادخل إلى معلومات حسابك وإعداداتك.'
      },
      tabs: {
        label: 'علامات تبويب بوابة المريض',
        tasksTitle: 'مهامي',
        tasksDesc: 'إجراءاتك اليومية التي يجب القيام بها.',
        monitoringTitle: 'متابعتي',
        monitoringDesc: 'متابعتك وقياساتك.',
        agendaTitle: 'أجندتي',
        agendaDesc: 'مواعيدك وفعالياتك.',
        messengerTitle: 'رسائلي',
        messengerDesc: 'تواصل مع فريق الرعاية.',
        documentsTitle: 'مستنداتي',
        documentsDesc: 'جميع مستنداتك.'
      },
      tasks: {
        label: 'مهامي',
        title: 'مهامي',
        desc: 'ستجد هنا الإجراءات التي يجب إكمالها: الاستبيانات والمواعيد والمستندات للمراجعة.',
        counterTitle: 'عداد المهام',
        counterDesc: 'عدد الأنشطة المجدولة لإكمالها اليوم وعدد الأنشطة الحرة.',
        priorityTitle: 'أنشطة ذات أولوية',
        priorityDesc: 'الإجراءات الأكثر أهمية أو المتأخرة تظهر هنا.',
        todayTitle: 'مجدولة اليوم',
        todayDesc: 'الإجراءات المجدولة لليوم تظهر هنا.',
        upcomingTitle: 'قادمة',
        upcomingDesc: 'الإجراءات المجدولة القادمة تظهر هنا.',
        freeTitle: 'أنشطة حرة',
        freeDesc: 'استبيانات اختيارية يمكنك إكمالها في أي وقت.',
        cleanupAlert: 'تم حذف بيانات المهام التجريبية.',
        congratsTitle: 'تهانينا!',
        congratsDesc: 'لقد أكملت الجولة الإرشادية للمهام. يمكنك الآن استخدام هذا القسم بشكل مستقل.'
      },
      events: {
        label: 'أجندتي',
        title: 'أجندتي',
        desc: 'اعرض الاستبيانات والمواعيد والمستندات المجدولة للمراجعة في التاريخ المحدد.',
        schedulerTitle: 'التقويم',
        schedulerDesc: 'اختر تاريخاً لعرض الأنشطة المجدولة لذلك اليوم.',
        listTitle: 'أنشطة اليوم',
        listDesc: 'اطلع على الاستبيانات والمواعيد والمستندات المجدولة لهذا التاريخ.',
        addTitle: 'إضافة نشاط',
        addDesc: 'خطط لاستبيان، موعد، أو أضف تذكيراً لتاريخ محدد.',
        cleanupAlert: 'تم حذف بيانات التقويم التجريبية.',
        outroTitle: 'تهانينا!',
        outroDesc: 'أنت الآن تعرف كيفية استخدام أجندتك.'
      },
      documents: {
        label: 'مستنداتي',
        title: 'مستنداتي',
        desc: 'ستجد هنا مستنداتك الشخصية والموارد التي يشاركها الفريق.',
        filterTitle: 'مرشحات البحث',
        filterDesc: 'إذا كان لديك العديد من المستندات، قم بتحسين العرض باستخدام أدوات البحث والفرز.',
        listTitle: 'قائمة المستندات',
        listDesc: 'اضغط على مستند لفتحه أو عرضه أو تنزيله.',
        addTitle: 'إضافة مستند',
        addDesc: 'قم بتحميل ملف أو التقط صورة لإضافتها إلى مستنداتك.',
        cleanupAlert: 'تم حذف بيانات المستندات التجريبية.',
        outroTitle: 'تهانينا!',
        outroDesc: 'أنت الآن تعرف أين تجد مستنداتك.'
      },
      messages: {
        label: 'رسائلي',
        title: 'رسائلي',
        desc: 'تواصل مع فريق الرعاية الخاص بك، اعرض وأرسل الرسائل.',
        addTitle: 'إرسال رسالة',
        addDesc: 'اكتب رسالتك، أرفق ملفاً إذا لزم الأمر، ثم اضغط على إرسال.',
        cleanupAlert: 'تم حذف بيانات المراسلة التجريبية.',
        outroTitle: 'تهانينا!',
        outroDesc: 'أنت الآن تعرف كيفية استخدام المراسلة.'
      },
      monitoring: {
        label: 'متابعتي',
        title: 'متابعتي',
        desc: 'اعرض قياساتك والمحتوى التعليمي والسجل.',
        graphsTitle: 'بياناتي',
        graphsDesc: 'ستجد هنا قياساتك الأخيرة في شكل رسوم بيانية.',
        contentTitle: 'محتوى علاجي',
        contentDesc: 'مقاطع فيديو ومقالات ومستندات لمرافقتك.',
        historyTitle: 'السجل',
        historyDesc: 'إجراءاتك الأخيرة: الردود على الاستبيانات واستشارات المستندات.',
        cleanupAlert: 'تم حذف بيانات المتابعة التجريبية.',
        outroTitle: 'تهانينا!',
        outroDesc: 'أنت الآن تعرف كيفية الوصول إلى متابعتك بسهولة.'
      },
      home: {
        label: 'الصفحة الرئيسية',
        welcomeTitle: 'مرحباً بك في Aptelecare!',
        welcomeDesc: 'سنرشدك خطوة بخطوة لاستكشاف ميزات مساحة المريض الخاصة بك، لتتمكن من متابعة معلوماتك الصحية بسهولة وطمأنينة.\n\n**قد تظهر بعض البيانات التجريبية، لا تقلق، فسيتم حذفها تلقائياً عند انتهاء الجولة**.',
        countersTitle: 'ملخص نشاطك',
        countersDesc: 'تتبع تقدم رحلتك بسهولة: اطلع على مهامك المطلوب إكمالها ورسائلك الجديدة والمستندات التي يشاركها فريقك الطبي.',
        tasksTitle: 'مهامي',
        tasksDesc: 'ستجد هنا الإجراءات التي يجب إكمالها: الاستبيانات والمواعيد والمستندات للمراجعة.',
        monitoringTitle: 'متابعتي',
        monitoringDesc: 'اعرض قياساتك وتقدم رعايتك.',
        documentsTitle: 'مستنداتي',
        documentsDesc: 'الوصول إلى مستنداتك الطبية.',
        messagesTitle: 'رسائلي',
        messagesDesc: 'تواصل بشكل آمن مع فريق الرعاية.',
        agendaTitle: 'أجندتي',
        agendaDesc: 'مواعيدك وفعالياتك.',
        outroTitle: 'تهانينا!',
        outroDesc: 'أنت الآن تعرف بوابة المريض الخاصة بك. لا تتردد في العودة بانتظام لتتبع معلوماتك الصحية والبقاء على اتصال مع فريقك الطبي.'
      },
      fakeData: {
        // Events
        eventsFollowupFormName: 'استبيان المتابعة',
        eventsFollowupFormLaterName: 'استبيان المتابعة (لاحقاً)',
        eventsRendezVousTitle: 'موعد هاتفي',
        eventsRendezVousDescription: 'مع الممرض(ة) المسؤول(ة) عنك.',
        eventsFreeFormOptionalName: 'استمارة المتابعة الأسبوعية (اختياري)',
        eventsFreeFormName: 'استمارة المتابعة الأسبوعية',
        eventsPlannedDocumentName: 'وثيقة معلومات',
        eventsPlannedDocumentFileName: 'دليل التحضير',
        eventsFollowupFormTomorrowName: 'استبيان المتابعة (غداً)',

        // Graphs
        graphsBpTitle: 'ضغط الدم',
        graphsIndicatorSystolicName: 'الانقباضي',
        graphsIndicatorDiastolicName: 'الانبساطي',
        graphsWeightTitle: 'الوزن',
        graphsIndicatorWeightName: 'الوزن',

        // Messages
        messagesWelcome: 'مرحباً، أهلاً بك في رسائلك الآمنة. لا تتردد في طرح أسئلتك.',
        messagesQuestion: 'شكراً! هل يجب علي الإجابة على الاستبيان اليوم؟',
        messagesAnswer: 'نعم، يمكنك إكماله الآن.',

        // Documents
        document1: 'فيديو: الاستعداد الجيد لموعدي',
        document2: 'كتيب: معلومات عملية',
        document3: 'مقال: نصائح يومية',

        // Therapeutic content
        therapeuticContent1: 'دليل: فهم متابعتي',
        therapeuticContent2: 'فيديو: التنفس والاسترخاء',

        // History
        historyFormName: 'استبيان المتابعة'
      }
    }
  }
}
